import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import { fomatFloat } from "@/utils/utils.js";

// element
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

// 导入公共方法
import "@/utils/mixin.js";

// 导入全局导航守卫
import "@/permission.js";

// 导入全局icon
import "./assets/font/iconfont.css";

//导入签名插件
import vueSignature from "vue-signature";

Vue.use(ElementUI);
Vue.use(vueSignature);

Vue.config.productionTip = false;
Vue.prototype._fomatFloat = fomatFloat;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
